import { render } from "./MewTabs.vue?vue&type=template&id=5311767f&scoped=true&ts=true"
import script from "./MewTabs.vue?vue&type=script&lang=ts"
export * from "./MewTabs.vue?vue&type=script&lang=ts"

import "./MewTabs.vue?vue&type=style&index=0&id=5311767f&lang=scss"
import "./MewTabs.vue?vue&type=style&index=1&id=5311767f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5311767f"]])

export default __exports__